import { Button, Col, Divider, Modal, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { bailiffJobPreviewSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
import TriggerBailiffPreview from "./trigger/trigger_bailiff_preview";
import { useJobPreview } from "hook/bailiff/job/action/useJobRefine";
import CardBailiffPreview from "component/cards/job/card_bailiff_preview";
import { useJobDeposit } from "hook/bailiff/job/action/useJobDeposit";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogBailiffPreview = () => {
  // -------------------------- VAR -----------------------------
  const { sentences } = useJobPreview();
  const { loading, handleDeposit, handleClosePreview } = useJobDeposit();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const selected = useSelector(bailiffJobPreviewSelector);
  const open = !!selected;
  //   const open = true;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderDialogs = () => {
    return (
      <div
        className="h-[400px] overflow-y-auto"
        style={{
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: 8,
        }}
      >
        <Row style={{ padding: 16 }}>
          {sentences?.map((item, index) => {
            return (
              <Col key={index} xl={24} lg={24} md={24} xs={24}>
                <CardBailiffPreview data={item} />
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleClosePreview}
      open={open}
      footer={null}
      title="Bản xem trước file đã phiên dịch"
      style={{ zIndex: 1 }}
      width={600}
    >
      <Row gutter={[16, 16]}>
        <Divider style={{ margin: "8px 0px" }} dashed />
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderDialogs()}
        </Col>
        <Divider style={{ margin: "8px 0px" }} dashed />
        <Col xl={24} lg={24} md={24} xs={24}>
          <Button
            loading={loading}
            disabled={loading}
            style={{ minHeight: 40, borderRadius: 5 }}
            type="primary"
            block
            onClick={() => handleDeposit(selected)}
          >
            Thanh toán để tải file
          </Button>
        </Col>
      </Row>
      <TriggerBailiffPreview />
    </Modal>
  );
};
export default DialogBailiffPreview;
